// extracted by mini-css-extract-plugin
export default {"container":"S02_container__XFHVC","limiter":"S02_limiter__hVT2V"};